import { render } from "./ActivityStatisticsChart.vue?vue&type=template&id=09f5d8d2"
import script from "./ActivityStatisticsChart.vue?vue&type=script&lang=js"
export * from "./ActivityStatisticsChart.vue?vue&type=script&lang=js"

import "./ActivityStatisticsChart.vue?vue&type=style&index=0&id=09f5d8d2&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__